import React, { useEffect, useRef, useState } from "react";
import { BiHide, BiShowAlt } from "react-icons/bi";
import { CiShare1 } from "react-icons/ci";
import { FiUsers } from "react-icons/fi";
import { IoCopy } from "react-icons/io5";
import { SiBitcoinsv } from "react-icons/si";
import { useDispatch, useSelector } from "react-redux";
import { setUserId, setUserState, setshowcomponents } from "../Store/userslice";
import { GrNext, GrPrevious } from "react-icons/gr";
import { Bounce, ToastContainer, toast } from "react-toastify";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import Loader from "../Loader/Loader";
import USDTimg from "../../asstes/ustd.png";
const Forsagex3Details = () => {
  //----Redux States------
  const PartnersDetailsData = useSelector(
    (state) => state.user.PartnersDetailsData
  );
  const Lvl = useSelector((state) => state.user.Lvl);
  const UserId = useSelector((state) => state.user.UserId);
  const upline = PartnersDetailsData?.upline || 0;
  const dispatch = useDispatch();
  //---Nagivet DashBoard Function-----
  const HandleBack = () => {
    dispatch(setshowcomponents(0));
  };
  //------States-------------
  const [visibleItems, setVisibleItems] = useState(5);
  const [showMore, setShowMore] = useState(false);
  const [totalProfitUSDT, setTotalProfitUSDT] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  //--------PartnersDetailsData filter-----------
  const partner = PartnersDetailsData.partners?.map((item, index) => {
    const timestamp = item.time;
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
    //--------Sum Of USDT profit----------
    return {
      type: index + 1,
      Time: formattedDate,
      ID: item.userId,
      Level: "",
      Wallet: item.userAddress,
      Busd: item.profitAmount,
    };
  });
  //------Get USDT Profit---------
  useEffect(() => {
    let calculatedTotalProfit = 0;
    PartnersDetailsData.partners?.forEach((item) => {
      const profitUSDT = Number(item.profitAmount);
      calculatedTotalProfit += profitUSDT;
    });
    const formattedTotalProfit = calculatedTotalProfit.toString();
    // console.log("formattedTotalProfit",formattedTotalProfit)
    setTotalProfitUSDT(calculatedTotalProfit);
  }, [PartnersDetailsData]);

  //----Show Circles-------
  const circlesToShow = 3;
  // const handleNext = () => {
  //   setCurrentIndex((prevIndex) => {
  //     const newIndex = prevIndex + 1;
  //     if (newIndex + circlesToShow > partner.length) {
  //       return prevIndex;
  //     }
  //     return newIndex;
  //   });
  // };
  const sliderBodyRef = useRef(null);
  const handleNext = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex + 1;
      if (newIndex + circlesToShow > partner.length) {
        return prevIndex;
      }

      // Trigger the animation
      if (sliderBodyRef.current) {
        sliderBodyRef.current?.classList?.add("glowing");
        setTimeout(() => {
          sliderBodyRef.current?.classList?.remove("glowing");
        }, 3000); // Duration of the animation in milliseconds
      }

      return newIndex;
    });
  };
  //--------Next && Preview Buttons------
  const handlePrev = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex - 1;
      if (newIndex < 0) {
        return prevIndex;
      }

      // Trigger the animation
      if (sliderBodyRef.current) {
        sliderBodyRef.current?.classList?.add("glowing");
        setTimeout(() => {
          sliderBodyRef.current?.classList?.remove("glowing");
        }, 3000); // Duration of the animation in milliseconds
      }
      return newIndex;
    });
  };
  //-----------
  const renderCircles = () => {
    const start = currentIndex;
    const end = start + circlesToShow;
    return partner?.slice(start, end);
  };

  //------Copy Funtion------
  const handleCopy = (e) => {
    navigator.clipboard.writeText(e).then(
      () => {
        toast("Copied to clipboard!", {
          position: "bottom-left",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      },
      (err) => {
        console.error("Failed to copy: ", err);
      }
    );
  };
  //----Share Funtion-------
  const handleShare = (e) => {
    window.open(`https://testnet.bscscan.com/address/${e}`, "_blank");
  };
  const HandleSendId = (e) => {
    dispatch(setUserId(e));
    dispatch(setUserState(true));
    dispatch(setshowcomponents(0));
  };
  //-----Show More And Less Table Funtion -------
  const [showLoader, setshowLoader] = useState(false);
  const toggleShowMore = () => {
    if (showMore) {
      setshowLoader(true);
      setTimeout(() => {
        setVisibleItems(4);
        setshowLoader(false);
      }, 1000);
    } else {
      setshowLoader(true);
      setTimeout(() => {
        setVisibleItems(partner.length);
        setshowLoader(false);
      }, 1000);
    }
    setShowMore(!showMore);
  };
  //----Set UplinedId-----
  const HandleUpline = (UplineId) => {
    dispatch(setUserId(UplineId));
    dispatch(setUserState(true));
  };
  return (
    <>
      <div className="Forsagex3Details-main-div">
        <div className="Forsagex3Details-inner-div">
          <p className="Forsagex3-id-text">
            <span
              className="Forsagex3-text"
              onClick={() => HandleUpline(upline)}
            >
              ID {Lvl.UserId}/
            </span>
            <span className="Forsagex3-text" onClick={HandleBack}>
              Forsage x3 /
            </span>
            Levle {Lvl.Levels}
          </p>
          <h1 className="level-text">Level {Lvl.Levels}</h1>
        </div>
        <div className="Forsagex3Details-upline-div">
          <div className="Forsagex3Details-upline-text">
            <p>Upline</p>{" "}
            <p
              className="Forsagex3Details-upline-id"
              onClick={() => HandleUpline(upline)}
            >
              ID {upline}
            </p>
          </div>
        </div>
        <div className="Forsagex3Details-slider-div">
          <div className="slider-body " ref={sliderBodyRef}>
            <div className="slider-body-header">
              <div className="slider-body-header-inner-container">
                <h1 className="lvl-text">Lvl {Lvl.Levels}</h1>
              </div>
              <div  className="slider-body-header-inner-container">
                <h1>ID {UserId}</h1>
              </div>
              <div  className="slider-body-header-inner-container">
                <img src={USDTimg} alt="" className="usdt-img-frd3detailpage" />
                <h1 className="CiBitcoin-text lvl-text">{Lvl.LevelAmount}</h1>
              </div>
            </div>

            <div className="slider-body-cyrcle">
              <button onClick={handlePrev} className="Previous">
                <GrPrevious
                  className={`${currentIndex === 0 ? "disable" : ""}`}
                />
              </button>
              {renderCircles()?.map((circle) => (
                <div key={circle} className="cyrcle-one">
                  {circle.ID}
                </div>
              ))}
              <button onClick={handleNext} className="Previous">
                <GrNext className={`${currentIndex === 2 ? "disable" : ""}`} />
              </button>
            </div>
            <div className="slider-footer">
              <div className="slider-footer-Partners-div">
                <h1>Partners</h1>
                <h1 className="slider-footer-heading">
                  <FiUsers />
                  {partner?.length}
                </h1>
              </div>

              <div className="slider-footer-Total-level-div">
                <h1>Total level revenue</h1>
                <h1 className="slider-footer-heading">
                  <MdOutlineAccountBalanceWallet />
                  {totalProfitUSDT}
                </h1>
              </div>
            </div>
          </div>
        </div>
        {/* slider div end */}
        <div className="Forsagex3Details-data-table-div">
          <table className="Forsagex3Details-data-table">
            <thead>
              <tr>
                <td>Type</td>
                <td>Date</td>
                <td className="id-row">ID</td>
                <td>Level</td>
                <td>Wallet</td>
                <td>BUSD</td>
              </tr>
            </thead>
            <tbody>
              {partner?.slice(0, visibleItems).map((item, index) => (
                <tr key={index} className="table-row">
                  <td>{item.type}</td>
                  <td>{item.Time}</td>
                  <td
                    className="id-row id-td-row"
                    onClick={() => HandleSendId(item.ID)}
                  >
                    ID {item.ID}
                  </td>
                  <td>{Lvl.Levels}</td>
                  <td className="wallet-row">
                    {`${
                      item.Wallet?.slice(0, 6) + "..." + item.Wallet?.slice(-5)
                    }`}

                    <IoCopy
                      onClick={() => handleCopy(item.Wallet)}
                      className="partners-table-copy-icon"
                    />
                    <CiShare1
                      onClick={() => handleShare(item.Wallet)}
                      className="partners-table-copy-icon"
                    />
                  </td>
                  <td>{item.Busd}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="show-table" onClick={toggleShowMore}>
            <div className="show-table-inner-div">
              <span className="show-table-btn-span">
                {showMore ? (
                  <>
                    {showLoader ? (
                      <Loader />
                    ) : (
                      <>
                        See less <BiHide className="show-table-icon" />
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {showLoader ? (
                      <Loader />
                    ) : (
                      <>
                        See more <BiShowAlt className="show-table-icon" />
                      </>
                    )}
                  </>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default Forsagex3Details;
